import React from "react";
import "./BookingStepSection.scss";

type BookingStepSectionProps = {
  step: number;
  title: string;
  icon?: string;
  children: React.ReactNode;
  rtl?: boolean;
  className?: string;
};

const BookingStepSection: React.FC<BookingStepSectionProps> = ({
  step,
  title,
  icon,
  children,
  rtl = false,
  className = "",
}) => (
  <section
    className={`booking-step-section ${rtl ? "booking-step-section--rtl" : ""} ${className}`}
  >
    <div className="booking-step-section__header">
      <span className="booking-step-section__badge familysora600">{step}</span>
      {icon && <span className="booking-step-section__icon">{icon}</span>}
      <h3 className="booking-step-section__title familysora600">{title}</h3>
    </div>
    <div className="booking-step-section__body">{children}</div>
  </section>
);

export default BookingStepSection;
